/**
 * Fetch wrapper. All API calls go through here.
 *
 * - Credentials included (session cookie)
 * - Throws ApiError with parsed shape on non-2xx responses
 * - Base URL is `/api` (Vite proxy in dev, Nginx in prod)
 */

import { ofetch } from 'ofetch'

export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number,
    public details?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

type ApiResponse<T> =
  { ok: true; data: T } | { ok: false; error: { code: string; message: string; details?: unknown } }

export const api = ofetch.create({
  baseURL: '/api',
  credentials: 'include',
  retry: 0,
  onResponseError({ response }) {
    const body = response._data as ApiResponse<unknown> | undefined
    if (body && 'ok' in body && body.ok === false) {
      throw new ApiError(body.error.code, body.error.message, response.status, body.error.details)
    }
  },
})

export type { ApiResponse }
